import Overlay from "../../../Componentes/Overlay";
import SideMenu from "../../../Componentes/SideMenu";
import SideMenuBtn from "../../../Componentes/SideMenuBtn";
import { useModal } from "../../../contexts/ModalContext";

const SidebarBM = () => {

    const { closeModal, openModal } = useModal();

    const handleOpenEmailsNF = () => {

        closeModal();
        openModal("modalEmailsNF");

    }

    return(
        <>
            <Overlay state={ true } changeContent={ closeModal } >
                <SideMenu>
                    <SideMenuBtn
                        button="E-MAILS NOTA FISCAL"
                        clickFunc={handleOpenEmailsNF}
                    />
                </SideMenu>
            </Overlay>
        </>
    )
}

export default SidebarBM;